import { useEffect, useState } from 'react';

interface Props {
  to: number;
}

export const useTimer = ({ to }: Props) => {
  const [time, setTime] = useState(to);
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setTime((prev) => {
        if (prev === 0) {
          setFinished(true);

          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => {
      clearTimeout(timerId);
    };
  }, [time]);

  const minutes = Math.floor(time / 60);
  const seconds = time - minutes * 60;

  const addLeadingZero = (num: number) => `0${num}`;
  const splittedLeadingZero = (num: number) => [0, num];
  const isOneCharNumber = (num: number) => num.toString().length === 1;

  const addLeadingZeroIfOnCharNumber = (num: number) =>
    isOneCharNumber(num) ? addLeadingZero(num) : num;

  const addSplittedLeadingZeroIfOnCharNumber = (num: number) =>
    isOneCharNumber(num)
      ? splittedLeadingZero(num)
      : Array.from(String(num), Number);

  return {
    minutes,
    seconds,
    finished,
    addLeadingZeroIfOnCharNumber,
    addSplittedLeadingZeroIfOnCharNumber,
  };
};
